import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, MapPin, Phone, Mail, Clock, CreditCard } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" size="sm" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <div className="text-center mb-8">
          <h1 className="font-display text-4xl font-bold text-foreground mb-2">Contact Us</h1>
          <p className="text-muted-foreground">We'd love to hear from you</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Location Card */}
          <Card className="bg-card border-border shadow-card">
            <CardHeader>
              <CardTitle className="font-display text-xl flex items-center gap-2">
                <MapPin className="w-5 h-5 text-primary" />
                Location
              </CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              <p className="font-semibold text-foreground">La Olla Restaurant</p>
              <p>Drake Bay, Osa Peninsula</p>
              <p>Puntarenas Province</p>
              <p>Costa Rica</p>
            </CardContent>
          </Card>

          {/* Hours Card */}
          <Card className="bg-card border-border shadow-card">
            <CardHeader>
              <CardTitle className="font-display text-xl flex items-center gap-2">
                <Clock className="w-5 h-5 text-primary" />
                Meal Times
              </CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground space-y-2">
              <div className="flex justify-between">
                <span>Breakfast</span>
                <span className="text-foreground">6:00 AM - 8:00 AM</span>
              </div>
              <div className="flex justify-between">
                <span>Lunch</span>
                <span className="text-foreground">12:30 PM - 1:30 PM</span>
              </div>
              <div className="flex justify-between">
                <span>Dinner</span>
                <span className="text-foreground">6:30 PM - 7:30 PM</span>
              </div>
            </CardContent>
          </Card>

          {/* Contact Info Card */}
          <Card className="bg-card border-border shadow-card">
            <CardHeader>
              <CardTitle className="font-display text-xl flex items-center gap-2">
                <Mail className="w-5 h-5 text-primary" />
                Get in Touch
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center gap-3 text-muted-foreground">
                <Mail className="w-4 h-4" />
                <span>info@amayascorcovado.com</span>
              </div>
              <div className="flex items-center gap-3 text-muted-foreground">
                <Phone className="w-4 h-4" />
                <span>+506 XXXX-XXXX</span>
              </div>
            </CardContent>
          </Card>

          {/* Payment Methods Card */}
          <Card className="bg-card border-border shadow-card">
            <CardHeader>
              <CardTitle className="font-display text-xl flex items-center gap-2">
                <CreditCard className="w-5 h-5 text-primary" />
                Payment Methods
              </CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              <p className="mb-2">We accept the following payment methods:</p>
              <ul className="space-y-1">
                <li>• Cash (USD or Costa Rican Colones)</li>
                <li>• Credit Cards (Visa, MasterCard)</li>
                <li>• PayPal</li>
                <li>• Sinpe Móvil</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {/* Partner Hotels Section */}
        <Card className="mt-6 bg-card border-border shadow-card">
          <CardHeader>
            <CardTitle className="font-display text-xl">Partner Hotels</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">
              La Olla proudly serves guests from the following partner hotels and lodges:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-muted-foreground">
              <div>• Bird Brain Bungalows</div>
              <div>• Kinkajoungalows</div>
              <div>• Susan's Cabins</div>
              <div>• Casa Azul</div>
              <div>• Casa Ezequiel</div>
              <div>• Poormans Paradise</div>
              <div>• Las Palmeras</div>
              <div>• Eden Corcovado</div>
            </div>
          </CardContent>
        </Card>

        {/* Reservation Info */}
        <Card className="mt-6 bg-primary/10 border-primary/30 shadow-card">
          <CardContent className="py-6">
            <h3 className="font-display text-lg font-semibold text-foreground mb-2">
              Making a Reservation
            </h3>
            <p className="text-muted-foreground">
              To make a reservation, please scan the QR code located in your cabin. 
              This will take you to our reservation system where you can select your meals, 
              specify dietary requirements, and request room service if desired.
            </p>
            <p className="text-muted-foreground mt-2">
              <strong className="text-foreground">Note:</strong> Reservations and cancellations must be made at least 2 hours before the meal time.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
